import { render } from "./Filter.vue?vue&type=template&id=bfd5c696&scoped=true"
import script from "./Filter.vue?vue&type=script&lang=js"
export * from "./Filter.vue?vue&type=script&lang=js"

import "@vueform/slider/themes/default.css?vue&type=style&index=0&lang=css"
import "./Filter.vue?vue&type=style&index=1&id=bfd5c696&scoped=true&lang=css"

import exportComponent from "/Data/maps/detention/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfd5c696"]])

export default __exports__